var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { toast } from 'react-toastify';
const basesUrl = process.env.NODE_ENV == 'production' ? '/avn33/api' : 'http://localhost:5000/api';
export const useHttp = () => {
    const [loader, setLoader] = React.useState(false);
    const request = React.useCallback((url, method = 'GET', body = null, headers = {}) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (body) {
                body = JSON.stringify(body);
                headers['Content-Type'] = 'application/json';
            }
            headers['Cache-Control'] = 'no-cache';
            setLoader(true);
            const res = yield fetch(basesUrl + url, { method, body, headers, cache: 'no-cache' });
            const data = res.json();
            setLoader(false);
            return data;
        }
        catch (e) {
            toast.error('Ошибка в сервере');
            console.log(e);
        }
    }), []);
    return { loader, request };
};
